import Footer from "@/components/Footer";
import HBIcon from "@/components/HBIcon";
import { SEOHead } from "@/pageComponents/Zhuanti";
import {
  Topic,
  getL1Topics,
  getSubTopicsByL1,
  isAlias,
  isL1Topics,
} from "@/services/zhuanti";
import { serverSideNotFound } from "@/utils/server/serverSide";
import classNames from "classnames";
import { GetServerSideProps, GetServerSidePropsResult } from "next";
import Link from "next/link";
import styles from "./index.module.less";

export default ZhuantiList;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const l1Topics = await getL1Topics();
  if (!isL1Topics(l1Topics))
    return serverSideNotFound(context.res) as GetServerSidePropsResult<any>;
  const alias = context.query.alias || l1Topics[0].alias;
  if (!isAlias(alias))
    return serverSideNotFound(context.res) as GetServerSidePropsResult<any>;
  const l1TopicWithSubTopic = await getSubTopicsByL1(alias);
  return {
    props: {
      l1Topics,
      l1TopicWithSubTopic,
    },
  };
};

interface Props {
  l1Topics: Topic[];
  l1TopicWithSubTopic: Topic;
}

export function ZhuantiList(props: Props) {
  const { l1Topics, l1TopicWithSubTopic } = props;
  return (
    <div className={styles.container}>
      <SEOHead topic={l1TopicWithSubTopic} />
      <L1TopicList topics={l1Topics} />
      {l1TopicWithSubTopic ? (
        <SubTopics l1TopicWithSubTopic={l1TopicWithSubTopic} />
      ) : null}
      <Footer />
    </div>
  );
}

function L1TopicList(props: { topics: Topic[] }) {
  return (
    <div className={styles.left}>
      {props.topics.map((t) => {
        return (
          <Link href={`/zhuanti?alias=${t.alias}`} passHref key={t.id}>
            <a className={styles.l1TopicListItem}>
              <span className={styles.textEllipsis}>{t.keyword}</span>
              <HBIcon type="ic_chevron_right" />
            </a>
          </Link>
        );
      })}
    </div>
  );
}

function SubTopics(props: { l1TopicWithSubTopic: Topic }) {
  const { children = [], alias, keyword } = props.l1TopicWithSubTopic;
  return (
    <div className={styles.right}>
      <Link href={`/zhuanti/${alias}`} passHref>
        <a className={styles.l1TopicTitle}>{keyword}</a>
      </Link>
      <div className={styles.l2TopicWrap}>
        {children.map((l2Topic) => {
          return (
            <div className={styles.l2Topic} key={l2Topic.id}>
              <Link
                href={`/zhuanti/${l2Topic.alias}`}
                key={l2Topic.id}
                passHref
              >
                <a className={styles.l2TopicTitle}>{l2Topic.keyword}</a>
              </Link>
              <div className={styles.l3TopicWrap}>
                {l2Topic.children?.map((l3Topic) => {
                  return (
                    <Link
                      href={`/zhuanti/${l3Topic.alias}`}
                      key={l3Topic.id}
                      passHref
                    >
                      <a
                        className={classNames(
                          styles.l3Topic,
                          styles.textEllipsis
                        )}
                      >
                        {l3Topic.keyword}
                      </a>
                    </Link>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
